import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio34: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAspectRatio34"><Path d="M19.5 2.5H4.5V21.5H19.5V2.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio34;
